const enumValue = description => Object.freeze({toString: () => description});

export const NAME = enumValue('NAME');
export const DATE_CREATED = enumValue('DATE_CREATED');
export const LAST_EXECUTION = enumValue('LAST_EXECUTION');
export const NO_SORT = enumValue('');